import get from 'src/utils/lodash-alternatives';
import { makeValidated } from '../utils';
import interpolate from '../interpolate';
import schema from '../../schema/batch-layout-operations.schema.json';
import initLayout from './initLayout';
import setLayoutProperty from './setLayoutProperty';
import mergeLayoutProperty from './mergeLayoutProperty';
import showLayoutComponent from './showLayoutComponent';
import hideLayoutComponent from './hideLayoutComponent';
import setComponentChildren from './setComponentChildren';
import setComponentsMap from './setComponentsMap';

const mapChildAction = (context, event, meta) => {
  const type = get(meta, 'action.type');
  const supportedActions = {
    initLayout,
    setLayoutProperty,
    mergeLayoutProperty,
    showLayoutComponent,
    hideLayoutComponent,
    setComponentChildren,
    setComponentsMap,
  };
  if (supportedActions[type] === undefined) {
    throw new Error(
      `Action type "${type}" is not supported by "batchLayoutOperations".`
    );
  }
  const supportedAction = supportedActions[type];
  return supportedAction(context, event, meta);
};

const mapBatchLayoutOperations = action => ({
  type: 'LAYOUT_BATCH',
  payload: action.data,
});

const pureBatchLayoutOperations = (context, event, meta) => {
  const validated = makeValidated(schema);
  const action = validated(interpolate(meta.action, event, context));
  return mapBatchLayoutOperations({
    type: action.type,
    data: (action.data || []).map(childAction =>
      mapChildAction(context, event, { action: childAction })
    ),
    meta: action.meta,
  });
};

export default pureBatchLayoutOperations;
